import React from 'react';
import { useParams } from 'react-router-dom';
import LinearProgress from '@material-ui/core/LinearProgress';

import GrantsBanner from 'assets/pageBanners/grants.avif';
import { useSigmaReportByTypeQuery } from 'generated/graphql';
import { PageBannerContainer } from 'components/PageBannerContainer/PageBannerContainer';
import { SigmaEmbed } from 'components/SigmaEmbed/SigmaEmbed';

import { RouteParams } from './types';

const SigmaReport: React.FC = () => {
  const { type } = useParams<RouteParams>();

  const { data: reportData, loading } = useSigmaReportByTypeQuery({
    fetchPolicy: 'network-only',
    variables: {
      type,
    },
  });

  const { sigmaUrl = '' } = reportData?.getSigmaReport || {};

  const isGrants = type === 'grants';

  if (loading) {
    return <LinearProgress />;
  }

  return (
    <>
      {isGrants && (
        <PageBannerContainer
          color="#82E0DB"
          backgroundImage={GrantsBanner}
          style={{ marginBottom: 32 }}
        >
          <h1>Grants</h1>
        </PageBannerContainer>
      )}

      <SigmaEmbed sigmaUrl={sigmaUrl} />
    </>
  );
};

export default SigmaReport;
